import { render } from "./ApplicationSetting.vue?vue&type=template&id=2ef4a16f&scoped=true"
import script from "./ApplicationSetting.vue?vue&type=script&lang=js"
export * from "./ApplicationSetting.vue?vue&type=script&lang=js"

import "./ApplicationSetting.vue?vue&type=style&index=0&id=2ef4a16f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef4a16f"]])

export default __exports__